<script setup lang="ts">
import { computed } from 'vue';
import { Typography, Stack } from '@apparatix/library/core';
import type { Content } from '@apparatix/types/AccountProfiles';
import { useAiProfileValidation, useUtilities } from '@apparatix/composables';
import InvalidProfileContent from './InvalidProfileContent.vue';
import ProfileListContent from './ProfileListContent.vue';

type Props = {
  contents: Content<'composite-list'>;
}

const props = defineProps<Props>();

const isEmpty = computed(() => !props.contents);

const { validateCompositeListSchema } = useAiProfileValidation();

const { forKeys } = useUtilities();

const isValidSchema = computed(() => validateCompositeListSchema(props.contents));

const propsAsMap = computed<Map<string, string[]>>(() => {
  const map = new Map<string, string[]>();
  forKeys(props.contents, (key, value: string[]) => {
    map.set(key, value);
  });

  return map;
});
</script>
<template>
  <Stack v-if="isValidSchema" :gap="4">
    <template v-for="item in propsAsMap.entries()" :key="item[0]">
      <Typography variant="section-subheading">
        {{ item[0] }}
      </Typography>
      <ProfileListContent :contents="item[1]" />
    </template>
  </Stack>
  <InvalidProfileContent v-if="!isValidSchema" :empty="isEmpty" />
</template>
